import { Component, OnInit } from '@angular/core';
import { INavMenu } from '../navbar/navbar.component';
import { NavbarService } from '../_services/navbar.service';
import { MatRadioChange } from '@angular/material';
import { SesssionActivityService } from '../_services/sesssion-activity.service';
import { AuthService } from '../_services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-learning-status',
  templateUrl: './learning-status.component.html',
  styleUrls: ['./learning-status.component.css']
})
export class LearningStatusComponent implements OnInit {
  breadcrumbTitle: string = 'Learning';
  navItemSelected: string = '';

  percentage;
  userDetailsId = 0;
  userDataSession;
  
  
  navMenu: INavMenu[] = [];

  constructor(private navbarService: NavbarService,
    private sesssionActivityService: SesssionActivityService,
    private authService :AuthService,
    private router: Router
  ) {
    
  }

  ngOnInit() {
    this.navItemSelected = this.navbarService.getActiveNavItem();
    // ===== Get navbar menu item value through service =====
    this.userDataSession = this.authService.getUserData();
    this.navMenu = this.navbarService.getNavMenu();
    this.getLearningSatatus(this.userDataSession.userDetailsId);
  }

  getLearningSatatus(id) {
    this.sesssionActivityService.getLastSessionActiityPercentageByUserId(id).subscribe(
      resp => {
        this.percentage = resp;
        this.navMenu.forEach((item, index) => {
        if(this.percentage.inventionPercentage == "100" && (index == 1 || index == 2) )
        {
          item.disableOption = false;
        }else if(this.percentage.drawingPercentage == "100" && (index == 3 || index == 4)) {
          item.disableOption = false;
        }else if(this.percentage.searchPercentage == "100" && (index == 5 || index == 6)){
          item.disableOption = false;
        }else if(this.percentage.draftPercentage == "100" && index == 7){
          item.disableOption = false;
        }
        });
      }, error => {
        console.log(error);
      })
  }

  optionSelect(event: MatRadioChange){
    let selectedValue = event.value;
    this.navbarService.saveActiveNavItem(selectedValue);
    switch (selectedValue) {
      case "Basics of Patents":
      this.router.navigate(['/main/learning/learnBasicOfPatents']);
        break;
        case "Basics of Patents Quiz":
        this.router.navigate(['/main/learning/basicOfPatentTest']);
        break;
        case "Patent Drawing":
        this.router.navigate(['/main/learning/learnPatentDrawing']);
        break;
        case "Patent Search":
        this.router.navigate(['/main/learning/learnPatentSearch']);
        break;
        case "Patent Search Quiz":
        this.router.navigate(['/main/learning/patentSearchTest']);
        break;
        case "Patent Drafting":
        this.router.navigate(['/main/learning/learnPatentDraft']);
        break;
        case "Patent Drafting Quiz":
        this.router.navigate(['/main/learning/patentDraftTest']);
        break;
        case "Patent Filing":
        this.router.navigate(['/main/learning/learnPatentFiling']);
        break;
      default:
      this.router.navigate(['/main/learning/learnBasicOfPatents']);
        break;
    }
  }

}
